import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';
import Header from '../../../components/Header';
import { getDealers, updateBoxStatus, updateDealerStatus } from '../../../redux/slice/dealer.slice';
import { useSnackbar } from 'notistack';

const Commision = () => {
    const DealerRegister = useSelector(state => state.dealer.Dealer) || [];
    const dispatch = useDispatch();
    const userId = localStorage.getItem('id');
    const { enqueueSnackbar } = useSnackbar();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedDealers, setSelectedDealers] = useState([]);


    useEffect(() => {
        dispatch(getDealers());
    }, []);

    useEffect(() => {
        const dataToSubmit = (Array.isArray(DealerRegister) ? DealerRegister : []).filter(dealer => dealer.userId === userId && dealer.isDisabled);
        setSelectedDealers(dataToSubmit);
    }, [DealerRegister, userId]);
    const isSubmittingRef = useRef(false);

    const handleSubmit = async (ids) => {
        console.log(ids);
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;

        const submitDate = new Date().toISOString();

        if (selectedDealers.length > 0) {
            setIsDisabled(true);
            setIsSubmitting(true);

            if (Array.isArray(ids)) {
                console.log(ids);
                handleUpdateDealerStatus({ ids, submitDate });
            }

            selectedDealers.forEach(dealer => {
                if (dealer.requestStatus === "Pending") {

                }
            });
            enqueueSnackbar("Request is Submitted", { variant: 'success', autoHideDuration: 2000, anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            setIsSubmitting(false);
            isSubmittingRef.current = false;
        }
        dispatch(getDealers());
    };

    const handleUpdateDealerStatus = async ({ ids, submitDate }) => {
        console.log(ids);
        await dispatch(updateDealerStatus({ ids, submitDate }))
        // await dispatch(updateDealerStatus({ ids, submitDate })).then((res) => {
        //     selectedDealers.forEach(dealer => {
        //         if (dealer.boxStatus === "Enabled") {
        //             dispatch(updateBoxStatus({ id, submitDate }));
        //         }
        //     });
        // });
        await dispatch(getDealers());
    };

    const isMobile = useMediaQuery('(max-width:500px)');

    const currentDate = new Date();
    const cutoffDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const groupDealersByCommissionPeriod = (data) => {
        console.log(data);

        // const grouped = {};
        // let isFirstEntry = true;

        // dealers.forEach(dealer => {
        //     const dateTo = new Date(dealer.commisionCreatedAt);
        //     const year = dateTo.getFullYear();
        //     const month = dateTo.getMonth();
        //     const day = dateTo.getDate();
        //     if (dealer.submitDate) {
        //         const periodKey = `${year}-${month + 1}`;
        //         if (!grouped[`${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`]) {
        //             console.log("periodKey", `${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`);
        //             const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
        //             const endDate = new Date(year, month + 1, 0);
        //             grouped[`${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`] = {
        //                 startDate,
        //                 endDate,
        //                 formattedStartDate: startDate.toLocaleDateString('en-GB'),
        //                 formattedEndDate: endDate.toLocaleDateString('en-GB'),
        //                 dealers: [],
        //                 submitDate: dealer.submitDate
        //             };
        //             isFirstEntry = false;
        //             grouped[`${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`].dealers.push(dealer);
        //         } else {
        //             grouped[`${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`].dealers.push(dealer);
        //         }
        //     } else {
        //         const periodKey = `${year}-${month + 1}`;

        //         if (!grouped[periodKey]) {
        //             const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
        //             const endDate = new Date(year, month + 1, 0);
        //             grouped[periodKey] = {
        //                 startDate,
        //                 endDate,
        //                 formattedStartDate: startDate.toLocaleDateString('en-GB'),
        //                 formattedEndDate: endDate.toLocaleDateString('en-GB'),
        //                 dealers: [],
        //             };
        //             isFirstEntry = false;
        //             grouped[periodKey].dealers.push(dealer);
        //         } else {
        //             grouped[periodKey].dealers.push(dealer);
        //         }

        //     }
        // });
        // return grouped;
        const arr = Array.isArray(data) ? data : [];
        return arr.reduce((acc, item) => {
            const key = item.billNo ? item.billNo : 'no-bill';
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
    };

    const filteredDealers = (Array.isArray(DealerRegister) ? DealerRegister : []).filter(dealer =>
        dealer.userId === userId &&
        dealer.isDisabled &&
        new Date(dealer.commisionCreatedAt) <= currentDate
    );

    const groupedDealers = groupDealersByCommissionPeriod(filteredDealers);

    console.log("groupedDealers", groupedDealers);


    const sortedPeriods = Object.entries(groupedDealers).sort((a, b) =>
        new Date(b[1].endDate) - new Date(a[1].endDate)
    );

    const accountPayableFileNumbers = [];
    // sortedPeriods.forEach(([periodKey, data]) => {
    //     const formattedStartDate = data.formattedStartDate;
    //     const formattedEndDate = data.formattedEndDate;
    //     const accountPayableValue = data.dealers.reduce((total, dealer) => {
    //         const paymentDetails = dealer.dealerPaymentDetails || [];
    //         const matchingPayment = paymentDetails.find(a =>
    //             a.dealermonth === `${formattedStartDate} - ${formattedEndDate}`
    //         );
    //         return matchingPayment;
    //     }, 0)
    //     if (accountPayableValue && accountPayableValue.DealerPaymentDetails.some(payment => payment.DealerPaymentTotal > 0)) {
    //         data.dealers.forEach(dealer => {
    //             accountPayableFileNumbers.push(dealer.data?.[0]?.fillNo || 'N/A');
    //         });
    //     }
    // });

    const sortedFab = Object.entries(groupedDealers)
        .map(([key, records]) => ({
            key,
            data: records
        }))
        .sort((a, b) => {
            if (a.key === "no-bill") return -1;
            if (b.key === "no-bill") return 1;

            const latestA = new Date(a.data[0].commisionCreatedAt);
            const latestB = new Date(b.data[0].commisionCreatedAt);
            return latestB - latestA; // descending
        });

    console.log("sortedFab", sortedFab);


    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            <Header
                title="DEALER COMMISSION"
                subtitle="Manage Your Dealer Commission Here"
            />

            {/* {sortedPeriods.length > 0 ? (
                sortedFab?.map(({ key, data }, index) => (
                    // .sort((a, b) => {
                    //     const aOpacity = a[1].dealers.some(dealer => dealer.requestStatus === "Pending") && a[1].dealers.some(dealer => dealer.boxStatus === "Enabled") ? 1 : 0.5;
                    //     const bOpacity = b[1].dealers.some(dealer => dealer.requestStatus === "Pending") && b[1].dealers.some(dealer => dealer.boxStatus === "Enabled") ? 1 : 0.5;
                    //     return bOpacity - aOpacity;
                    // })
                    // .map(([periodKey, data], index) => (
                        <Box key={index} sx={{
                            m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                            bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD",
                            color: theme.palette.mode === 'dark' ? 'white' : "black",
                            // opacity: data.dealers.some(a => a.requestStatus === "Pending") && data.dealers.some(a => a.boxStatus === "Enabled") ? 1 : 0.5,
                            // pointerEvents: data.dealers.some(a => a.requestStatus === "Pending") && data.dealers.some(a => a.boxStatus === "Enabled") ? "auto" : "none",
                        }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Box sx={{ fontSize: '14px', fontWeight: '600', display: 'flex', justifyContent: 'space-between', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            Invoice Time Period: {data?.formattedStartDate} to{' '}
                                            {data.dealers.some(dealer => dealer.submitDate)
                                                ? new Date(data.dealers.find(dealer => dealer.submitDate).submitDate).toLocaleDateString('en-GB')
                                                : data.formattedEndDate}
                                        </Typography>

                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            Status: {data.dealers.reduce((status, dealer) => {
                                                const paymentDetails = dealer.dealerPaymentDetails || [];
                                                const matchingPayment = paymentDetails.find(a =>
                                                    a.dealermonth === `${data.formattedStartDate} - ${new Date(data.submitDate).toLocaleDateString('en-GB')}`)?.status || 'Pending';
                                                return matchingPayment;
                                            }, 'Pending')}
                                        </Typography>
                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            Date Of Payment: {data.dealers.reduce((total, dealer) => {
                                                const paymentDetails = dealer.dealerPaymentDetails || [];
                                                const matchingPayment = paymentDetails.find(a =>
                                                    a.dealermonth === `${data.formattedStartDate} - ${new Date(data.submitDate).toLocaleDateString('en-GB')}`)?.DealerPaymentDetails.slice(-1)[0]?.DealerPaymentDate;
                                                return matchingPayment ? new Date(matchingPayment).toLocaleDateString('en-GB') : 'N/A';
                                            }, 'N/A')}
                                        </Typography>

                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            Dealer Name: {data.dealers[0]?.userDetails[0]?.name || 'N/A'}
                                        </Typography>
                                        <Typography variant="h6" sx={{ mb: 2, mr: 4 }}>
                                            <Button variant='contained' color='primary' onClick={handleSubmit} style={{ float: 'right' }}>Send to Account Department</Button>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table style={{ width: '100%' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>File No</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Name</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>City</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Mobile No.</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>System Size</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Commision Per KW</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Dealer Commission</TableCell>
                                                    <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Account Payable</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>

                                                {data.dealers.map((dealer, index) => {
                                                    const paymentDetails = dealer.dealerPaymentDetails || [];
                                                    const formattedDealermonth = `${data.formattedStartDate} - ${new Date(data.submitDate).toLocaleDateString('en-GB')}`;
                                                    const matchingPaymentDetails = paymentDetails?.filter((a) => a.dealermonth === formattedDealermonth);
                                                    const currentFileNo = dealer.data?.[0]?.fillNo;
                                                    const dealerPayments = matchingPaymentDetails.length > 0
                                                        ? matchingPaymentDetails[0].DealerPaymentDetails?.filter(payment => payment.fileNo === currentFileNo)
                                                        : [];

                                                    const displayedPayments = dealerPayments.length > 0
                                                        ? dealerPayments.map((payment) => (
                                                            <div key={payment._id}>
                                                                {payment.DealerPaymentTotal}
                                                            </div>
                                                        ))
                                                        : '-';
                                                    const isLastDealer = index === data.dealers.length - 1;
                                                    const extraPayments = isLastDealer && matchingPaymentDetails.length > 0
                                                        ? matchingPaymentDetails[0].DealerPaymentDetails?.filter(payment => !payment.fileNo)
                                                        : [];

                                                    return (
                                                        <>
                                                            <TableRow>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                                    {dealer.data?.[0]?.fillNo || 'N/A'}
                                                                </TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealer.data?.[0]?.ConsumerName || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                                    {dealer.data?.[0]?.City_Village || 'N/A'}
                                                                </TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealer.data?.[0]?.PhoneNumber || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealer.data?.[0]?.SystemSizeKw || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealer.data?.[0]?.CommissionPerKW || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealer.dealerCommission || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                                    {displayedPayments}
                                                                </TableCell>
                                                            </TableRow>
                                                            {isLastDealer && extraPayments.map((extraPayment) => (
                                                                <TableRow key={extraPayment._id}>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>-</TableCell>
                                                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{extraPayment.DealerPaymentTotal || 'N/A'}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </>
                                                    );
                                                })}
                                            </TableBody>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {data.dealers.reduce((acc, curr) => acc + Number(curr.dealerCommission), 0).toFixed(2)}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {data.dealers.reduce((total, dealer) => {
                                                        const paymentDetails = dealer.dealerPaymentDetails || [];
                                                        const matchingPayment = paymentDetails.find(a => a.dealermonth === `${data.formattedStartDate} - ${new Date(data.submitDate).toLocaleDateString('en-GB')}`);
                                                        const accountPayableValue = matchingPayment?.DealerPaymentDetails.reduce((total, payment) => total + payment.DealerPaymentTotal, 0) || 0;
                                                        return accountPayableValue;
                                                    }, 0).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Box>
                    ))
            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        Oops ! No Results Found.
                    </Typography>
                </Box>
            )} */}
            {sortedFab.length > 0 ? (
                <>
                    {sortedFab?.map(({ key, data }, index) => {
                        console.log("key, data", key, data);

                        // const fabricatedata = data?.map(item => item?.eledata?.[0]);
                        // const FabricatorName = data[0]?.assignInstallerData[0]?.febricianName;

                        // console.log("data[0]?.assignInstallerData[0]?.", data[0]?.assignInstallerData[0]);


                        let totalAmt = data?.reduce((acc, v) => acc + parseFloat(v?.dealerCommission), 0);

                        console.log(totalAmt);


                        // let givenAmt = data?.reduce((acc, v) => {
                        //     const amount = parseFloat(v?.paymentAmount ?? 0);
                        //     const tds = parseFloat(v?.tds ?? 0);
                        //     return acc + amount + tds;
                        // }, 0);

                        // const givenAmt = data.reduce(
                        //     (acc, record) => {
                        //         // collect all fileNos from data array of this record
                        //         const fileNos = record.data?.map(d => d.fillNo) || [];

                        //         // go through all dealerPaymentDetails of this record
                        //         (record.dealerPaymentDetails || []).forEach(dealerDetail => {
                        //             (dealerDetail.DealerPaymentDetails || []).forEach(payment => {
                        //                 if (fileNos.includes(payment.fileNo)) {
                        //                     const amount = Number(payment.DealerPaymentAmount || 0);
                        //                     const tds = Number(payment.DealerPaymentTDS || 0);

                        //                     acc.DealerPaymentAmount += amount;
                        //                     acc.DealerPaymentTDS += tds;
                        //                     acc.grandTotal += amount + tds;
                        //                 }
                        //             });
                        //         });

                        //         return acc;
                        //     },
                        //     { DealerPaymentAmount: 0, DealerPaymentTDS: 0, grandTotal: 0 }
                        // ).grandTotal;

                        // console.log(givenAmt);
                        // let givenAmt = 0;
                        // const result = {
                        //     overall: { DealerPaymentAmount: 0, DealerPaymentTDS: 0, grandTotal: 0 },
                        //     fileNoWise: {} // { fileNo: { DealerPaymentAmount, DealerPaymentTDS, grandTotal } }
                        // };

                        // data.forEach(record => {
                        //     const fileNos = record.data?.map(d => d.fillNo) || [];

                        //     (record.dealerPaymentDetails || []).forEach(dealerDetail => {
                        //         (dealerDetail.DealerPaymentDetails || []).forEach(payment => {
                        //             if (fileNos.includes(payment.fileNo)) {
                        //                 const amount = Number(payment.DealerPaymentAmount || 0);
                        //                 const tds = Number(payment.DealerPaymentTDS || 0);

                        //                 // update overall totals
                        //                 result.overall.DealerPaymentAmount += amount;
                        //                 result.overall.DealerPaymentTDS += tds;
                        //                 result.overall.grandTotal += amount + tds;

                        //                 // update fileNo-wise totals
                        //                 if (!result.fileNoWise[payment.fileNo]) {
                        //                     result.fileNoWise[payment.fileNo] = {
                        //                         DealerPaymentAmount: 0,
                        //                         DealerPaymentTDS: 0,
                        //                         grandTotal: 0
                        //                     };
                        //                 }

                        //                 result.fileNoWise[payment.fileNo].DealerPaymentAmount += amount;
                        //                 result.fileNoWise[payment.fileNo].DealerPaymentTDS += tds;
                        //                 result.fileNoWise[payment.fileNo].grandTotal += amount + tds;
                        //             }
                        //         });
                        //     });
                        // });

                        // const records = yourData; // your array of objects

                        const result = {
                            overall: {
                                DealerPaymentAmount: 0,
                                DealerPaymentTDS: 0,
                                grandTotal: 0,
                                latestDealerPaymentDate: null
                            },
                            fileNoWise: {} // { fileNo: { DealerPaymentAmount, DealerPaymentTDS, grandTotal } }
                        };

                        data.forEach(record => {
                            const fileNos = record.data?.map(d => d.fillNo) || [];

                            (record.dealerPaymentDetails || []).forEach(dealerDetail => {
                                (dealerDetail.DealerPaymentDetails || []).forEach(payment => {
                                    if (fileNos.includes(payment.fileNo)) {
                                        const amount = Number(payment.DealerPaymentAmount || 0);
                                        const tds = Number(payment.DealerPaymentTDS || 0);

                                        // update overall totals
                                        result.overall.DealerPaymentAmount += amount;
                                        result.overall.DealerPaymentTDS += tds;
                                        result.overall.grandTotal += amount + tds;

                                        // update latestDealerPaymentDate (if valid date)
                                        if (payment.DealerPaymentDate) {
                                            const payDate = new Date(payment.DealerPaymentDate);
                                            if (
                                                !result.overall.latestDealerPaymentDate ||
                                                payDate > new Date(result.overall.latestDealerPaymentDate)
                                            ) {
                                                result.overall.latestDealerPaymentDate = payment.DealerPaymentDate;
                                            }
                                        }

                                        // update fileNo-wise totals
                                        if (!result.fileNoWise[payment.fileNo]) {
                                            result.fileNoWise[payment.fileNo] = {
                                                DealerPaymentAmount: 0,
                                                DealerPaymentTDS: 0,
                                                grandTotal: 0
                                            };
                                        }

                                        result.fileNoWise[payment.fileNo].DealerPaymentAmount += amount;
                                        result.fileNoWise[payment.fileNo].DealerPaymentTDS += tds;
                                        result.fileNoWise[payment.fileNo].grandTotal += amount + tds;
                                    }
                                });
                            });
                        });

                        console.log(result);


                        console.log(result);

                        const latestDate = data
                            ?.map(e => new Date(e?.paymentDate))
                            .filter(date => !isNaN(date)) // remove invalid dates
                            .sort((a, b) => b - a)[0];

                        console.log(latestDate);


                        const formattedLatestDate = latestDate?.toLocaleDateString();

                        console.log(formattedLatestDate);

                        return (
                            <Box key={index} sx={{
                                m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                                bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD",
                                color: theme.palette.mode === 'dark' ? 'white' : "black",
                            }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Box sx={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            overflowX: 'auto',
                                            whiteSpace: 'nowrap',
                                            '& > *:not(:last-child)': {
                                                marginRight: '25px',
                                            }
                                        }}>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Invoice Date: {data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}
                                            </Typography>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Invoice No:
                                                {`Dealer/${data[0]?.userDetails[0]?.name}/${data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}/${key}`}
                                            </Typography>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Status: {result?.overall?.grandTotal >= totalAmt ? 'Complete' : "Pending"}
                                            </Typography>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Date of Payment: {result?.overall?.latestDealerPaymentDate}
                                            </Typography>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Dealer Name: {data[0]?.userDetails[0]?.name}
                                            </Typography>

                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                <Button variant='contained' color='primary' disabled={isSubmitting} sx={{
                                                    opacity: data?.some(a => a?.requestStatus === "Pending") ? 1 : 0.5,
                                                    pointerEvents: data?.some(a => a?.requestStatus === "Pending") ? "auto" : "none",

                                                }} onClick={() => handleSubmit(data?.map(a => a._id))}>
                                                    Send to Account
                                                </Button>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TableContainer>
                                            <Table style={{ width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>File No</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Name</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>City</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Mobile No.</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>System Size</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Commision Per KW</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Dealer Commission</TableCell>
                                                        <TableCell sx={{ fontSize: '15px', fontWeight: '600', whiteSpace: 'nowrap' }}>Account Payable</TableCell>
                                                    </TableRow>

                                                </TableHead>
                                                <TableBody>
                                                    {data.map((rate, index) => {
                                                        const marketData = rate?.data?.[0];

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.fillNo}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.ConsumerName}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.City_Village}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.PhoneNumber || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.SystemSize}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.CommissionPerKW || 'N/A'}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.dealerCommission}</TableCell>
                                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                                    {result?.fileNoWise[marketData?.fillNo]?.grandTotal}
                                                                    {/* {rate?.paymentAmount + rate?.tds || 0} */}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    <TableRow>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                            {Number(totalAmt).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                            {result?.overall?.grandTotal || 0}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Box>
                        )
                    })}
                </>
            ) : (
                <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4 }}>
                    No Data Availble
                </Typography>
            )}
        </Box>
    );
};

export default memo(Commision);